import { BaseHttpService } from 'app/services';
import { IFunding, IList } from 'modules/products/services/hooks/interfaces';
import { OriginatorType } from './types';

export class OriginatorServiceHttpService extends BaseHttpService {
  BASE_URL = `${process.env.REACT_APP_DASHBOARD_API_HOST}/proxy`;

  getOriginators = async (): Promise<IList<OriginatorType>> => {
    const res = await this.get(`${this.BASE_URL}/issuer/originators?size=9999`);
    return res.data;
  };

  getOriginator = async (originatorId: string): Promise<OriginatorType> => {
    const res = await this.get(
      `${this.BASE_URL}/issuer/originators/${originatorId}`,
    );
    return res.data;
  };

  getOriginatorFundings = async (
    originatorId: string,
  ): Promise<IList<IFunding>> => {
    const res = await this.get(
      `${this.BASE_URL}/issuer/originators/${originatorId}/fundings`,
    );
    return res.data;
  };
}
